// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2lsYr","buttons":"Footer_buttons__1UQBj"};